import { render, staticRenderFns } from "./signUpFieldsC.vue?vue&type=template&id=63407fdb&"
import script from "./signUpFieldsC.vue?vue&type=script&lang=js&"
export * from "./signUpFieldsC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports